/**
 * Copy der Version „Aivy Balance“: mehr Menschlichkeit und mehr Automatisierung
 * sind kein Widerspruch. Die Stimmen sind sinngemäß und anonymisiert aus
 * Kundengesprächen (Feedback Sources, Okt. 2026), die Belege stammen aus
 * Feedback-Signalen und dem Demo-Deck. Die Woche ist ein illustratives Beispiel.
 */

const de = {
  ui: {
    chapters: 'Kapitel',
    demo: 'Demo buchen',
    start: 'Kostenlos starten',
    dock: 'Mehr Zeit für Menschen?',
    illustrative: 'Beispielwoche, illustrativ',
    voices: 'Sinngemäß aus Kundengesprächen, anonymisiert'
  },
  chapters: {
    paradox: 'Der Widerspruch',
    stimmen: 'Was Kund:innen sagen',
    woche: 'Eine Recruiting-Woche',
    menschlicher: 'Wo es menschlicher wird',
    kette: 'Wer entscheidet',
    belege: 'Belege',
    start: 'Loslegen'
  },
  paradox: {
    human: 'Mehr Menschlichkeit.',
    auto: 'Alles automatisieren.',
    clash: 'Klingt wie ein Widerspruch.',
    lead: ['Automatisieren,', 'damit es menschlicher wird.'],
    sub: 'Die Maschine übernimmt, was Menschen nicht gut beurteilen können. Menschen bekommen Zeit für das, was nur sie können.'
  },
  stimmen: {
    title: 'Beides steht im selben Gespräch.',
    human: 'Wunsch nach Mensch',
    auto: 'Wunsch nach Zeit',
    humanQuotes: [
      'Wir wollen nicht komplett auf das menschliche Auge verzichten.',
      'Manche geben perfekte Antworten und passen trotzdem nicht. Andere verkaufen sich schlecht und würden besser passen.',
      'Die letzte KI-Lösung war eher störend als entlastend.'
    ],
    autoQuotes: [
      'Das Screening bindet die gesamte Kapazität des Teams.',
      'Für Active Sourcing bleibt keine Zeit.',
      'Interviews werden terminiert, und nach fünf Minuten ist klar, dass es nicht passt.'
    ]
  },
  woche: {
    eyebrow: 'Eine Recruiting-Woche, 40 Stunden',
    before: 'Heute geht die meiste Zeit an Unterlagen.',
    after: 'Mit Aivy geht sie an Menschen.',
    auto: 'Übernimmt Aivy',
    human: 'Zeit mit Menschen',
    hours: 'Std.',
    blocks: {
      sichten: 'Bewerbungen sichten',
      unpassend: 'Erstgespräche ohne Passung',
      termine: 'Termine und Einladungen',
      abstimmen: 'Abstimmung mit dem Fachbereich',
      gespraeche: 'Gespräche mit passenden Talenten',
      sourcing: 'Active Sourcing',
      feedback: 'Feedback und Onboarding',
      rest: 'Sonstiges'
    },
    steps: [
      {
        title: 'Aivy misst, bevor jemand sichtet.',
        text: 'Jede Bewerbung bekommt automatisch das Assessment, das Ergebnis ist gegen eure Anforderungen gerechnet. Aus Stunden Sichtung werden Minuten.'
      },
      {
        title: 'Nur noch Gespräche, die sich lohnen.',
        text: 'Ins Erstgespräch kommt, wer zur Stelle passt. Die Gespräche, bei denen nach fünf Minuten alles klar ist, fallen weg.'
      },
      {
        title: 'Einladungen laufen von allein.',
        text: 'Über euer ATS startet die Einladung beim Statuswechsel. Niemand verschickt Links von Hand.'
      },
      {
        title: 'Die frei gewordene Zeit gehört Menschen.',
        text: 'Mehr Gespräche mit den Richtigen, Zeit für Active Sourcing und für ehrliches Feedback an alle, die sich beworben haben.'
      }
    ]
  },
  menschlicher: {
    title: 'Drei Stellen, an denen Automatisierung menschlicher macht.',
    points: [
      {
        title: 'Talente, die der Lebenslauf versteckt',
        text: 'Ein Talent mit hohem Score stand auf keiner Prio-Liste. Es wurde eingeladen und eingestellt.',
        source: 'AHA-Moment aus dem Kundenalltag'
      },
      {
        title: 'Bessere Gespräche statt mehr Gespräche',
        text: 'Die Gesprächshinweise im Passungsprofil sind für viele der wichtigste Teil, oft wichtiger als der Score.',
        source: 'AHA-Moment aus dem Kundenalltag'
      },
      {
        title: 'Jede:r bekommt etwas zurück',
        text: 'Alle Bewerbenden erhalten ihr Stärkenprofil. Das spielbasierte Format regt zur Selbstreflexion an, statt Wissen abzufragen.',
        source: 'AHA-Moment aus dem Kundenalltag'
      }
    ]
  },
  kette: {
    title: 'Aivy entscheidet nicht. Menschen entscheiden besser.',
    nodes: [
      {
        who: 'Mensch',
        title: 'Setzt die Messlatte',
        text: 'Ihr legt fest, was die Stelle braucht. Das schafft Vertrauen in die Ergebnisse.'
      },
      {
        who: 'Aivy',
        title: 'Hält sie für alle gleich ein',
        text: 'Misst, rechnet und bereitet vor. Ohne Bauchgefühl und ohne Lebenslauf-Filter.'
      },
      {
        who: 'Mensch',
        title: 'Führt das Gespräch und entscheidet',
        text: 'Mit Hinweisen, was im Interview vertieft werden sollte.'
      }
    ],
    note: 'Wichtig: früh einsetzen. Wer Aivy erst nach der Sichtung nutzt, macht Gespräche besser, spart aber keine Zeit.',
    noteSource: 'Lernsignal aus einem Kundenprojekt'
  },
  belege: {
    title: 'Was das im Alltag heißt.',
    items: [
      {
        value: '1 von 3',
        label: 'Gesprächen erfolgreich statt 1 von 5',
        source: 'Kunde, Post-Sales'
      },
      {
        value: '11 → 6',
        label: 'Monate Recruitingzeitraum',
        source: 'Kunde, Post-Sales'
      },
      {
        value: '70 %',
        label: 'weniger Aufwand in der Vorauswahl',
        source: 'Fallstudie Callways'
      }
    ]
  },
  start: {
    title: ['Weniger sichten.', 'Mehr sprechen.'],
    sub: 'Wir zeigen dir in der Demo, welche Teile deines Prozesses Aivy übernimmt und wo deine Zeit danach hingeht.'
  }
}

const en = {
  ui: {
    chapters: 'Chapters',
    demo: 'Book a demo',
    start: 'Start for free',
    dock: 'More time for people?',
    illustrative: 'Example week, illustrative',
    voices: 'Paraphrased from customer calls, anonymised'
  },
  chapters: {
    paradox: 'The contradiction',
    stimmen: 'What customers say',
    woche: 'A recruiting week',
    menschlicher: 'Where it gets more human',
    kette: 'Who decides',
    belege: 'Proof',
    start: 'Get started'
  },
  paradox: {
    human: 'More humanity.',
    auto: 'Automate everything.',
    clash: 'Sounds like a contradiction.',
    lead: ['Automate,', 'so it gets more human.'],
    sub: 'The machine takes over what people cannot judge well. People get time for what only they can do.'
  },
  stimmen: {
    title: 'Both come up in the same call.',
    human: 'Wanting people',
    auto: 'Wanting time',
    humanQuotes: [
      'We do not want to give up the human eye entirely.',
      'Some give perfect answers and still do not fit. Others sell themselves badly and would fit better.',
      'The last AI tool got in the way more than it helped.'
    ],
    autoQuotes: [
      'Screening ties up the whole team.',
      'There is no time left for active sourcing.',
      'Interviews get scheduled, and after five minutes it is clear it does not fit.'
    ]
  },
  woche: {
    eyebrow: 'One recruiting week, 40 hours',
    before: 'Today most of the time goes to documents.',
    after: 'With Aivy it goes to people.',
    auto: 'Done by Aivy',
    human: 'Time with people',
    hours: 'h',
    blocks: {
      sichten: 'Screening applications',
      unpassend: 'First calls without fit',
      termine: 'Scheduling and invites',
      abstimmen: 'Aligning with the team',
      gespraeche: 'Talks with fitting talent',
      sourcing: 'Active sourcing',
      feedback: 'Feedback and onboarding',
      rest: 'Other'
    },
    steps: [
      {
        title: 'Aivy measures before anyone screens.',
        text: 'Every application gets the assessment automatically, matched against your requirements. Hours of screening become minutes.'
      },
      {
        title: 'Only calls that are worth it.',
        text: 'Whoever fits the role gets the first call. The calls that are over after five minutes disappear.'
      },
      {
        title: 'Invites run on their own.',
        text: 'Your ATS triggers the invite on a status change. Nobody sends links by hand.'
      },
      {
        title: 'The time you win belongs to people.',
        text: 'More talks with the right people, time for active sourcing and for honest feedback to everyone who applied.'
      }
    ]
  },
  menschlicher: {
    title: 'Three places where automation makes it more human.',
    points: [
      {
        title: 'Talent the CV hides',
        text: 'A candidate with a high score was on nobody’s shortlist. They were invited and hired.',
        source: 'AHA moment from a customer'
      },
      {
        title: 'Better talks instead of more talks',
        text: 'For many, the interview hints in the fit profile are the most important part, often more than the score.',
        source: 'AHA moment from a customer'
      },
      {
        title: 'Everyone gets something back',
        text: 'Every applicant receives their strength profile. The game-based format invites self-reflection instead of testing knowledge.',
        source: 'AHA moment from a customer'
      }
    ]
  },
  kette: {
    title: 'Aivy does not decide. People decide better.',
    nodes: [
      {
        who: 'Human',
        title: 'Sets the bar',
        text: 'You define what the role needs. That builds trust in the results.'
      },
      {
        who: 'Aivy',
        title: 'Applies it equally to everyone',
        text: 'Measures, matches and prepares. No gut feeling and no CV filter.'
      },
      {
        who: 'Human',
        title: 'Has the conversation and decides',
        text: 'With hints on what to dig into in the interview.'
      }
    ],
    note: 'Important: use it early. If you only use Aivy after screening, your talks get better, but you save no time.',
    noteSource: 'Learning from a customer project'
  },
  belege: {
    title: 'What this means day to day.',
    items: [
      {
        value: '1 in 3',
        label: 'talks successful instead of 1 in 5',
        source: 'Customer, post-sales'
      },
      {
        value: '11 → 6',
        label: 'months to fill roles',
        source: 'Customer, post-sales'
      },
      {
        value: '70 %',
        label: 'less effort in pre-selection',
        source: 'Callways case study'
      }
    ]
  },
  start: {
    title: ['Less screening.', 'More talking.'],
    sub: 'In the demo we show you which parts of your process Aivy takes over and where your time goes afterwards.'
  }
}

export const BALANCE_COPY = { de, en }
